export enum DataWizardUploadImportSessionErrorCodes {
  ExceedsEntitlement = 2,
}
